import { Helmet } from "react-helmet";
import { Heading, Img, Button, Text } from "../../components";
import CarCard from "../../components/CarCard";
import UserProfile1 from "../../components/UserProfile1";
import React, { Suspense, useEffect, useState, useCallback, useRef, useMemo } from "react";
import RightSideMenuProvider from "components/RightSideMenuProvider";
import MyAdsProvider from "components/MyAdsProvider";
import FilterBar from "components/FilterBar";
import AllCarsLines from "components/TestFile1AfterRow";
import axios from "axios";
import { API_DOMAIN_IMG, API_DOMAIN } from 'config';
import { useLocation, useNavigate } from 'react-router-dom';
import CarsTable from "components/CarsTable";
import useDisplayMode from "useDisplayMode";
import useInfiniteScroll from "components/UseInfiniteScroll";
import { JoyrideTour, isOnboardingStateSyncReady, isTourDone, getCatalogTourSteps, useTour } from "../../onboarding";
const carTabs = [
  "מודעות חדשות",
    "כל המודעות",
  "מודעות בארכיון",

  "מודעות במכרז",
];

const offerTabs = [
  "הצעות ממתינות לאישור",  "הצעות שאושרו",  "הצעות שנדחו",


];

const TAB_FILTERS = {
  "כל המודעות": {},

  "מודעות חדשות": {
    withoutOffersOnly: 1,
    approvedOther: 0,
    excludeNotInt: 1
  },

  "מודעות בארכיון": {
    archiveOnly: 1
  },

  "מודעות במכרז": {
    auctionOnly: 1
  },
};


export default function CarCatalogDealer({ currentUser, setGlobalCounters, setDealerCounters }) {
    const location = useLocation();
    const navigate = useNavigate();
    const {
      endTour,
      isManualTour,
      runCatalogTour,
      setIsCatalogReady,
      setStepIndex,
      stepIndex,
    } = useTour();

    const getInitialTab = () => {
    const t = location.state?.defaultTab;
return t && carTabs.includes(t) ? t : "מודעות חדשות";
  };
  const [activeTab, setActiveTab] = useState(getInitialTab);
  const [displayMode, setDisplayMode] = useDisplayMode();
  const [filters, setFilters] = useState({});
  const [reload, setReload] = useState(false);
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobileTour, setIsMobileTour] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(max-width: 768px)").matches;
  });
  const [page, setPage] = useState(() => {
    const urlPage = new URLSearchParams(location.search).get("page");
    return urlPage ? Number(urlPage) : 1;
  });
  const [hasMore, setHasMore] = useState(true);
  const PAGE_SIZE = 8;
  const [actionLoading, setActionLoading] = useState(false);
const requestGenerationRef = useRef(0);
const isAuctionTab = activeTab === carTabs[3];


const goToOfferTab = (tab) => {
navigate("/my-offers", { state: { defaultTab: tab }, replace: true });
};

const normalizeCarsResponse = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.cars)) return data.cars;
  console.error("Unexpected cars response:", data);
  return [];
};

const mergeUniqueCars = (current, incoming) => {
  const byId = new Map();
  [...current, ...incoming].forEach((car) => {
    const key = car?.id ?? car?.car_id;
    if (key === undefined || key === null) return;
    byId.set(String(key), car);
  });
  return Array.from(byId.values());
};

  const handleDisplayMode = (mode) => {
    setDisplayMode(mode);
    localStorage.setItem("displayMode", mode);
  };

const sentinelRef = useInfiniteScroll(() => {
  if (loading || actionLoading || !hasMore) return;
  setPage(p => p + 1);
}, { enabled: !loading && !actionLoading && hasMore });

const handleCardUpdate = async (carId, newStatus) => {
  setActionLoading(true);

  let needFill = false;

  setCars(prev => {
    const next = prev.filter(c => c.id !== carId);
    needFill = next.length < PAGE_SIZE;
    return next;
  });

  try {
    if (needFill && hasMore) {
      await fetchCars(page + 1, false);
    }
    setReload(v => !v);
  } finally {
    setActionLoading(false);
  }
};




  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    sp.set("page", page);
    window.history.replaceState({}, "", `${location.pathname}?${sp.toString()}`);
  }, [page, location.pathname, location.search]);

  const fetchCars = useCallback(async (pageToLoad = 1, reset = false, generation = requestGenerationRef.current) => {
    if (!currentUser?.id) return;
    setLoading(true);
    const params = {
      userId: currentUser.id,
      priceMin: filters.priceMin,
      priceMax: filters.priceMax,
      manufacturers: (filters.manufacturers ?? []).join(','),
      models: (filters.models ?? []).join(','),
      years: (filters.years ?? []).join(','),
      carTypes: (filters.carTypes ?? []).join(','),
      accidentTypes: (filters.accidentTypes ?? []).join(','),
      saleTypes: (filters.saleTypes ?? []).join(','),
      hasLicenseDoc: filters.hasLicenseDoc,
      hasPriceListDoc: filters.hasPriceListDoc,
      hasPartsListDoc: filters.hasPartsListDoc,
      auctionStatus: filters.auctionStatus,
      ...TAB_FILTERS[activeTab],
      page: pageToLoad,
      pageSize: PAGE_SIZE,
    };
    try {
      const { data } = await axios.get(`${API_DOMAIN}/car/filterCars`, { params });
      if (generation !== requestGenerationRef.current) return;
      const list = normalizeCarsResponse(data);

      setCars(prev => reset ? list : mergeUniqueCars(prev, list));
      setHasMore(list.length === PAGE_SIZE);
    } catch (err) {
      if (generation !== requestGenerationRef.current) return;
      console.error("שגיאה בשליפת רכבים:", err);
      if (reset) setCars([]);
      setHasMore(false);
    } finally {
      if (generation === requestGenerationRef.current) {
        setLoading(false);
      }
    }
  }, [currentUser?.id, filters, activeTab]);

useEffect(() => {
  if (actionLoading) return;

  if (page > 1) {
    fetchCars(page, false);
  }

  const refreshMs = isAuctionTab ? 15000 : 120000;
  const t = setInterval(() => {
    if (!actionLoading) fetchCars(1, true);
  }, refreshMs);

  return () => clearInterval(t);
}, [fetchCars, page, actionLoading, isAuctionTab]);


  useEffect(() => {
    const nextGeneration = requestGenerationRef.current + 1;
    requestGenerationRef.current = nextGeneration;
    setPage(1);
    setCars([]);
    setHasMore(true);
    fetchCars(1, true, nextGeneration);
  }, [filters, activeTab, currentUser?.id, fetchCars]);

  useEffect(() => {
    if (!currentUser?.id) return;
    const loadCounters = async () => {
      const base = { userId: currentUser.id };
      const count = async (filterObj = {}, clientFilter = null) => {
        const params = Object.fromEntries(
          Object.entries({ ...base, ...filterObj }).map(([k, v]) =>
            Array.isArray(v) ? [k, v.join(",")] : [k, v]
          )
        );
        const { data } = await axios.get(`${API_DOMAIN}/car/filterCars`, { params });
        const list = normalizeCarsResponse(data);
        return clientFilter ? list.filter(clientFilter).length : list.length;
      };
      const all = await count();
      const news = await count(TAB_FILTERS["מודעות חדשות"], c => c.offer_status !== 5);
      const dismantling = await count({ saleTypes: "1" });
      const rehabilitation = await count({ saleTypes: "2" });
      const archive = await count(TAB_FILTERS["מודעות בארכיון"], c => [3, 4, 5].includes(c.offer_status));
      const auctionFilter = { auctionOnly: 1 };
      const auctionAll = await count(auctionFilter);
      const auctionFuture = await count(auctionFilter, c => {
        const start = c.auction_start_datetime ? new Date(c.auction_start_datetime).getTime() : 0;
        return start > Date.now();
      });
      setGlobalCounters({ all, new: news, dismantling, rehabilitation, archive, cars_auction: auctionAll - auctionFuture, cars_auction_future: auctionFuture });
    };
    loadCounters();
    const refreshMs = isAuctionTab ? 15000 : 120000;
    const t = setInterval(loadCounters, refreshMs);
    return () => clearInterval(t);
  }, [currentUser?.id, reload, cars.length, isAuctionTab]);
useEffect(() => {
  const t = location.state?.defaultTab;
  if (t && carTabs.includes(t)) {
    setActiveTab(t);
  }
}, [location.key, location.state]);

const hasCatalogCars = (cars?.length ?? 0) > 0;

useEffect(() => {
  if (typeof window === "undefined" || !window.matchMedia) return;

  const mq = window.matchMedia("(max-width: 768px)");
  const updateIsMobileTour = () => setIsMobileTour(mq.matches);
  updateIsMobileTour();

  if (mq.addEventListener) {
    mq.addEventListener("change", updateIsMobileTour);
    return () => mq.removeEventListener("change", updateIsMobileTour);
  }

  mq.addListener(updateIsMobileTour);
  return () => mq.removeListener(updateIsMobileTour);
}, []);

// פונקציה לבדיקת targets מוכנים
const areTargetsReady = (steps) => {
  return steps.every((step) => {
    const elements = Array.from(document.querySelectorAll(step.target));
    if (elements.length === 0) return false;

    return elements.some((element) => {
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number(style.opacity) !== 0 &&
        rect.width > 0 &&
        rect.height > 0
      );
    });
  });
};

// יצירת steps דינמית עם useMemo כדי שלא ייווצרו מחדש בכל render
const catalogTourSteps = useMemo(() => {
  return getCatalogTourSteps(isMobileTour);
}, [isMobileTour]);

const onboardingSyncReady = isOnboardingStateSyncReady(currentUser?.id);
const isManualCatalogTour = isManualTour("catalog");
const canRunCatalogTour =
  runCatalogTour &&
  Number(currentUser?.user_type) === 3 &&
  onboardingSyncReady &&
  !loading &&
  hasCatalogCars &&
  (isManualCatalogTour || !isTourDone("catalog", currentUser?.id)) &&
  areTargetsReady(catalogTourSteps);

useEffect(() => {
  setIsCatalogReady(!loading && hasCatalogCars);
  
  if (process.env.NODE_ENV === "development") {
    console.log('[Catalog] State update:', {
      loading,
      hasCatalogCars,
      runCatalogTour,
      stepIndex,
      canRunCatalogTour,
      onboardingSyncReady,
      isManualCatalogTour,
      isTourDone: isTourDone("catalog", currentUser?.id)
    });
  }

  return () => setIsCatalogReady(false);
}, [hasCatalogCars, loading, setIsCatalogReady, runCatalogTour, stepIndex, canRunCatalogTour, onboardingSyncReady, isManualCatalogTour, currentUser?.id]);

// בדיקה מחדש של targets כשהמצב משתנה
useEffect(() => {
  if (!runCatalogTour || loading || !hasCatalogCars) return;
  if (Number(currentUser?.user_type) !== 3) return;
  if (!onboardingSyncReady) return;
  if (!isManualCatalogTour && isTourDone("catalog", currentUser?.id)) return;
  
  const timer = setTimeout(() => {
    if (areTargetsReady(catalogTourSteps)) {
      // Targets מוכנים, אפשר להמשיך
      console.log('[Catalog Tour] All targets ready - tour should be running');
      console.log('[Catalog Tour] canRunCatalogTour:', canRunCatalogTour);
      console.log('[Catalog Tour] JoyrideTour props:', { run: canRunCatalogTour, stepIndex, tourName: 'catalog' });
    } else {
      console.warn('[Catalog Tour] Some targets not ready:', 
        catalogTourSteps.filter(step => !document.querySelector(step.target))
          .map(step => step.target)
      );
    }
  }, 300);
  
  return () => clearTimeout(timer);
}, [runCatalogTour, loading, hasCatalogCars, currentUser?.user_type, onboardingSyncReady, isManualCatalogTour, currentUser?.id, catalogTourSteps, canRunCatalogTour, stepIndex]);

useEffect(() => {
  if (canRunCatalogTour && displayMode !== "cards") {
    setDisplayMode("cards");
    localStorage.setItem("displayMode", "cards");
  }
}, [canRunCatalogTour, displayMode, setDisplayMode]);
  return (
    <>
      <JoyrideTour
        run={canRunCatalogTour}
        steps={catalogTourSteps}
        stepIndex={stepIndex}
        tourName="catalog"
        onEnd={(status) => endTour("catalog", undefined, status)}
        onStepChange={setStepIndex}
      />

      <div className="car-catalog-dealer flex bg-blue_gray-50 p-8 sm:p-4 " style={{paddingTop: '1.2rem'}}>
        <div className="w-[100%] items-start gap-4 md:flex-col" style={{ gap: '2%' }}>
          <div
            className="main-section flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4"
            style={{ minHeight: "95.5vh" }}
          >
            <header className="flex flex-col items-start gap-3">
              <div style={{width: '9%'}} className="ml-3 w-[9%] absolute top-0 left-0 h-8  flex items-center justify-center gap-4 rounded-br-[10px] md:px-5">
                <div className="flex w-full justify-center gap-1">
                  <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                    <span className="text-gray-900_04">&nbsp;</span>
                    <span className="font-heebo font-medium text-gray-600">רכבים</span>
                  </Heading>
                  <Img src="images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                </div>
                <div className="flex w-full items-center justify-center">
                  <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                    סוחר
                  </Heading>
                  <Img src="images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                </div>
              </div>
              <div className="flex items-center justify-between gap-5 mt-5 self-stretch md:flex-col">
<div className="flex w-[6%] justify-center gap-3.5 md:w-full hide-mobile">
  <Img
    src="images/img_button1_gray_100_01.svg"
    alt="Buttonone"
    onClick={() => handleDisplayMode("cards")}
    className="h-[32px] rounded-[10px] cursor-pointer"
  />
  <Img
    src="images/3lines.svg"
    alt="Buttonone"
    onClick={() => handleDisplayMode("lines")}
    className="h-[32px] rounded-[10px] cursor-pointer"
  />

 
</div>
<div
  style={{direction: 'rtl'}}
  className="nav-tabs flex justify-center gap-4 text-base flex-row md:gap-2 md:text-[14px]  border-b border-solid border-gray-200 "
  data-testid="catalog-nav-tabs"
>

  {carTabs.map((tab) => (
    <div
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`cursor-pointer text-center px-4 py-2 md:px-0 md:py-0 ${
        activeTab === tab
          ? "border-b text-black"
          : "text-gray-600"
      }`}
      style={activeTab === tab ? { borderBottomColor: "#CE0000" } : undefined}
    >
      {tab}
    </div>
  ))}  {offerTabs.map((tab) => (
    <div
      key={tab}
      onClick={() => goToOfferTab(tab)}
      className="cursor-pointer text-center text-gray-600 hover:text-black px-4 py-2 md:px-0 md:py-0"
    >
      {tab}
    </div>
  ))}

</div>

          <div className="flex shrink-0 items-center gap-3 whitespace-nowrap">
  <Heading
    size="heading9xl"
    as="h4"
    className="!font-heebo whitespace-nowrap text-[25px] font-bold lg:text-[21px]"
  >
    מודעות רכבים
  </Heading>
  <Img
    src="images/img_car_red_a700_03_1.svg"
    alt="Car"
    className="icon-mobile h-[36px] shrink-0"
  />
</div>
              </div>
            </header>
            <div className="flex flex-col gap-6">
              <FilterBar onChange={setFilters} />
              {displayMode === "cards" && !loading && (cars?.length ?? 0) === 0 ? (
                <div
                  className="w-full flex-1 flex items-center justify-center"
                  style={{ direction: "rtl", paddingTop: "96px" }}
                >
                  <div className="rounded-[16px] border border-gray-200 bg-white px-10 py-8 flex items-center gap-6">
                    <div className="flex items-center gap-4" style={{ direction: "ltr" }}>
                      <Img src="images/img_car_red_a700_03_1.svg" alt="car" className="h-[28px] w-[28px]" />
                      <div className="flex flex-col items-center text-center" style={{ direction: "rtl" }}>
                        <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">
                          אין כרגע תוצאות
                        </Heading>
                        <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">חפש משהו אחר</Heading>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="grid grid-cols-4 justify-center gap-5 gap-y-5 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1"
                  style={{ direction: "rtl" }}
                >
                  <Suspense fallback={<div>Loading feed...</div>}>
                    {displayMode === "cards" &&
                      cars?.map((car) => (
                        <CarCard key={car.id} currentUser={currentUser} onUpdate={handleCardUpdate} {...car} />
                      ))}
                    <div ref={sentinelRef} style={{ height: 1 }} />
                  </Suspense>
                </div>
              )}

              <div className="flex flex-col gap-2.5">
                {displayMode === "lines" && !loading && (cars?.length ?? 0) === 0 && (
                  <div
                    className="w-full flex items-center justify-center"
                    style={{ direction: "rtl", minHeight: "50vh" }}
                  >
                    <div className="rounded-[16px] border border-gray-200 bg-white px-10 py-8 flex items-center gap-6">
                      <div className="flex items-center gap-4" style={{ direction: "ltr" }}>
                        <Img src="images/img_car_red_a700_03_1.svg" alt="car" className="h-[28px] w-[28px]" />
                        <div className="flex flex-col items-center text-center" style={{ direction: "rtl" }}>
                          <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">
                            אין כרגע תוצאות
                          </Heading>
                          <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">חפש משהו אחר</Heading>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {displayMode === "lines" && (cars?.length ?? 0) > 0 && (
                  <>
                    <CarsTable cars={cars} currentUser={currentUser} onUpdate={handleCardUpdate} />
                    <div ref={sentinelRef} style={{ height: 1 }} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
